export default __webpack_public_path__ + "static/media/katia-silene-title.0c4c080f.png";